// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../Utils/baseQueryWithReauth";
import { UpsertReport } from "../components/ReportCatalog/ReportCatalog.interfaces";

// Define a service using a base URL and expected endpoints
export const exploreReportsAPI = createApi({
  reducerPath: "exploreReports",
  tagTypes: ["PostReport", "FavoriteReports"],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getReportCatalogData: builder.query({
      query: () => "ReportCatalog/v1/getReportCatalogData",
      providesTags: ["PostReport"]
    }),
    getReportDetails: builder.query({
      query: (id) => `ReportCatalog/v1/getReportDetails?${id}`,
      providesTags: ["PostReport"]
    }),
    getFavoriteReportsByLogin: builder.query({
      query: () => "ReportCatalog/getFavoriteReportsByLogin",
      providesTags: ["FavoriteReports"]
    }),
    insertOrUpdateFavoriteReports: builder.mutation({
      query(report) {
        return {
          url: "ReportCatalog/insertOrUpdateFavoriteReports",
          method: "POST",
          body: report
        };
      },
      invalidatesTags: ["FavoriteReports"]
    }),
    upsertReport: builder.mutation<void, UpsertReport>({
      query(report) {
        return {
          url: "ReportCatalog/v1/insertOrUpdateReportCatalogData",
          method: "POST",
          body: report
        };
      },
      invalidatesTags: ["PostReport"]
    }),
    insertRecentlyViewedReport: builder.mutation<
      boolean,
      {
        LoginName: string;
        LoginEmail: string;
        ReportId: string;
        Report: string;
      }
    >({
      query(body) {
        return {
          url: "ReportCatalog/insertRecentlyViewedReport",
          method: "POST",
          body
        };
      }
    })
  })
});

export const {
  useGetReportCatalogDataQuery,
  useGetReportDetailsQuery,
  useGetFavoriteReportsByLoginQuery,
  useInsertOrUpdateFavoriteReportsMutation,
  useInsertRecentlyViewedReportMutation,
  useUpsertReportMutation
} = exploreReportsAPI;
